import { render } from "./newsticker.vue?vue&type=template&id=3c28a3c1&scoped=true"
import script from "./newsticker.vue?vue&type=script&lang=js"
export * from "./newsticker.vue?vue&type=script&lang=js"

import "./newsticker.vue?vue&type=style&index=0&id=3c28a3c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c28a3c1"]])

export default __exports__